import { LookupServiceApiClient } from "raci-lookup-service-clientproxy";
import { MotorEndorsementApiClient } from "raci-motorendorsements-clientproxy";
import { MfaOtpApiClient } from "raci-otp-service-clientproxy";
import { useSessionIdStorageKey, useSsoApiClient } from "raci-react-library";
import { BypassService } from "raci-react-library-npe";
import {
  useNpeBffApiClient,
  useNpeLookupServiceApiClient,
  useNpeMfaOtpServiceApiClient,
} from "../../../__NPE__/useNpeApiClient";
import {
  ADB2C_CLIENT_ID,
  BFF_API_BASE_URL,
  LOOKUP_SERVICE_API_BASE_URL,
  MFA_OTP_SERVICE_API_BASE_URL,
} from "../../constants";

const useRealBffApiClient = () => {
  const sessionIdStorageKey = useSessionIdStorageKey();
  return useSsoApiClient({
    Client: MotorEndorsementApiClient,
    clientId: ADB2C_CLIENT_ID,
    apiBaseUrl: BFF_API_BASE_URL,
    sessionIdStorageKey,
  });
};

const useRealLookupServiceApiClient = () => {
  const sessionIdStorageKey = useSessionIdStorageKey();
  return useSsoApiClient({
    Client: LookupServiceApiClient,
    clientId: ADB2C_CLIENT_ID,
    apiBaseUrl: LOOKUP_SERVICE_API_BASE_URL,
    sessionIdStorageKey,
  });
};

const useRealMfaOtpServiceApiClient = () => {
  const sessionIdStorageKey = useSessionIdStorageKey();
  return useSsoApiClient({
    Client: MfaOtpApiClient,
    clientId: ADB2C_CLIENT_ID,
    apiBaseUrl: MFA_OTP_SERVICE_API_BASE_URL,
    sessionIdStorageKey,
  });
};

export let useApiClient = useRealBffApiClient;
export let useLookupServiceApiClient = useRealLookupServiceApiClient;
export let useMfaOtpServiceApiClient = useRealMfaOtpServiceApiClient;

if (
  import.meta.env.VITE_ENVIRONMENT === "LOCAL" ||
  import.meta.env.VITE_ENVIRONMENT === "DEV" ||
  import.meta.env.VITE_ENVIRONMENT === "SIT" ||
  import.meta.env.VITE_ENVIRONMENT === "UAT"
) {

  useApiClient = useNpeBffApiClient;
  useLookupServiceApiClient = useNpeLookupServiceApiClient;
  useMfaOtpServiceApiClient = useNpeMfaOtpServiceApiClient;

  if (import.meta.env.VITE_ENVIRONMENT === "UAT" && !BypassService.isUsingTestLaunchPage()) {
    useApiClient = useRealBffApiClient;
    useLookupServiceApiClient = useRealLookupServiceApiClient;
    useMfaOtpServiceApiClient = useRealMfaOtpServiceApiClient;
  }
}

export default useApiClient;
